/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Care_Log_Usage_Area_InvalidInputs */

const vi_error_care_log_usage_area_invalid = /** @type {(inputs: Error_Care_Log_Usage_Area_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bãi đang lọc không hợp lệ. Hãy chọn lại bãi trong danh sách.`)
};

/**

* @param {Error_Care_Log_Usage_Area_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_care_log_usage_area_invalid = /** @type {((inputs?: Error_Care_Log_Usage_Area_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Care_Log_Usage_Area_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_care_log_usage_area_invalid(inputs)
});